import React, { useState } from "react";
import collapse from "../../assets/collapse.png";
import expand from "../../assets/expand.png";
import "./styles.css";

const CollapsibleWidget = (props) => {
  const [display, setDisplay] = useState(false);
  return (
    <fieldset className={props.className}>
      <div className="collapsibleWidget_header">
        <div>{props.title && <legend>{props.title}</legend>}</div>
        <div
          onClick={() => {
            setDisplay((prevDisplay) => !prevDisplay);
          }}
        >
          {display ? (
            <img className="collapseIcn" src={collapse} alt="collapse_icn" />
          ) : (
            <img className="collapseIcn" src={expand} alt="expand_icn" />
          )}
        </div>
      </div>
      <div
        className="row"
        style={{
          display: display ? "block" : "none",
          backgroundColor: props.options,
        }}
      >
        {props.properties.map((prop) => prop.content)}
      </div>
    </fieldset>
  );
};

export default CollapsibleWidget;
